import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    products: [],
    quantity: 0,
    total: 0,
    isFetching: false,
    error: false,
  },
  reducers: {
    addProducttoCartStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    addProducttoCartSuccess: (state, action) => {
      state.isFetching = false;
      // state.quantity += 1;
      state.products = action.payload;
    },
    addProducttoCartFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;
    },
    getCartStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getCartSuccess: (state, action) => {
      state.isFetching = false;
      state.products = action.payload;
    },
    getCartFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    removeProducttoCartStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    removeProducttoCartSuccess: (state, action) => {
      state.isFetching = true;
      state.products = action.payload;
    },
    removeProducttoCartFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },

    removeFromCart(state, action) {
      console.log("action", action.payload._id);
      state.products.map((cartItem) => {
        console.log("cartItem", cartItem._id);
        console.log("action", action.payload._id);

        if (cartItem._id === action.payload._id) {
          const nextCartItems = state.products.filter(
            (item) => item._id !== action.payload._id
          );
          state.products = nextCartItems;
          state.quantity -= 1;
          state.total -= action.payload.price * action.payload.quantity;
        }
      });
    },
    clearCart(state, action) {
      state.products = [];
      state.quantity = 0;
      state.total = 0;
    },
  },
});

export const {
  addProducttoCartStart,
  addProducttoCartSuccess,
  addProducttoCartFailure,
  removeProducttoCartStart,
  removeProducttoCartSuccess,
  removeProducttoCartFailure,
  getCartStart,
  getCartSuccess,
  getCartFailure,
  removeFromCart,
  clearCart,
} = cartSlice.actions;
export default cartSlice.reducer;
